module.exports = __webpack_public_path__ + "static/media/Sharp-LCD-Specification-LS044Q7DH01-10-17-19.d1b2355f.pdf";